import { allEnumValues, ItemCardMultiPriceOptionDisplay, ItemCardPriceOptionDisplayHelper, MenuItemDisplayPricePrecalculation, MenuModifierPriceDisplayStyle, MenuModifierPriceDisplayStyleHelper, MenuPriceStyle, MenuSectionHeaderType, MenuSectionHeaderTypeHelper, QuickAddEligibility, QuickAddSimpleItemsMode, QuickAddSimpleItemsModeHelper, UserRight, } from '@biteinc/enums';
export const menuAppearanceSettingsSchema = {
    // MENU.APPEARANCE MODEL SETTINGS
    // APPEARANCE
    titleBarImage: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        displayName: 'Title Bar Image',
        keepAspectRatio: 'fit-height',
        size: {
            width: 900,
            height: 110,
        },
        tooltip: {
            text: 'If provided, this image is used in place of a text title at the top of the menu.',
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    useNewFulfillmentModalView: {
        type: 'bool',
        required: true,
        displayName: 'Show background image and title bar image on dining option modal',
        tooltip: {
            text: 'If turned on, will show the background images below, and the title bar above for dining option popups.',
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    fulfillmentBackgroundImage: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        displayName: 'Dining Option Modal Background Image',
        keepAspectRatio: 'contain',
        imagePrefix: 'fulfillmentBackground',
        size: {
            width: 2048,
            height: 2732,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    fulfillmentBackgroundImageWeb: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        displayName: 'Web Dining Option Modal Background Image',
        keepAspectRatio: 'contain',
        imagePrefix: 'fulfillmentBackground',
        size: {
            width: 2560,
            height: 1440,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    menuTitle: {
        displayName: 'Menu Title',
        type: 'shortString',
        tooltip: {
            text: 'If provided, this title is used in place of the org name at the top of the menu.',
        },
        tabId: 'menu-appearance-settings-v2',
    },
    fullScreenBackgroundImages: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 5,
        displayName: 'Backgrounds for Full Screen Views',
        imagePrefix: 'fsbg',
        size: {
            width: 768,
            height: 1024,
        },
        jpgSize: {
            width: 1536,
            height: 2048,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    defaultMenuSectionHeaderType: {
        type: 'stringEnum',
        enum: MenuSectionHeaderType,
        enumNameHelper: MenuSectionHeaderTypeHelper.name,
        required: true,
        displayName: 'Default Section Header Type',
        ui: 'dropdown',
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    sectionImages: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 5,
        displayName: 'Default menu section header',
        imagePrefix: 'sections',
        keepAspectRatio: 'fit-width',
        size: {
            width: 1080,
            height: 200,
        },
        tabId: 'menu-appearance-settings-v2',
    },
    deemphasizeCalories: {
        displayName: 'De-emphasize menu item calories',
        type: 'bool',
        required: true,
        tooltip: {
            text: 'Hide menu item calories when viewing the entire menu.',
        },
        tabId: 'menu-appearance-settings-v2',
    },
    menuDisclaimer: {
        type: 'longString',
        displayName: 'Menu Disclaimer',
        tooltip: {
            text: 'A statement for the guest, such as an allergen notice. Vitrine pins it above every menu page. GCN shows it on the first menu page.',
        },
        tabId: 'menu-appearance-settings-v2',
    },
    rewardsProgramLogo: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        displayName: 'Rewards Program Logo',
        keepAspectRatio: 'contain',
        size: {
            width: 240,
            height: 240,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    priceStyle: {
        type: 'int',
        required: true,
        values: allEnumValues(MenuPriceStyle),
        displayName: 'Price Style',
        ui: 'dropdown',
        tabId: 'menu-appearance-settings-v2',
    },
    modifierPriceDisplayStyle: {
        type: 'stringEnum',
        enum: MenuModifierPriceDisplayStyle,
        enumNameHelper: MenuModifierPriceDisplayStyleHelper.name,
        required: true,
        displayName: 'If modifiers all have the same price',
        ui: 'dropdown',
        tabId: 'menu-appearance-settings-v2',
    },
    precalculateMenuItemDisplayPrice: {
        displayName: 'Precalculate Menu Item Display Price',
        type: 'stringEnum',
        enum: MenuItemDisplayPricePrecalculation,
        required: true,
        ui: 'dropdown',
        tabId: 'menu-appearance-settings-v2',
    },
    showCurrencySymbol: {
        type: 'bool',
        required: true,
        displayName: 'Show $ in front of prices',
        tabId: 'menu-appearance-settings-v2',
    },
    footnotes: {
        type: 'array',
        elementType: 'longString',
        required: true,
        placeholder: 'add a new footnote',
        tabId: 'menu-appearance-settings-v2',
    },
    useStickyQuickNavigation: {
        type: 'bool',
        required: true,
        displayName: 'Use sticky quick navigation for menus',
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    useTwoRowNavBar: {
        type: 'bool',
        required: true,
        displayName: 'Use 2-rows for the nav bar',
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    quickAdd: {
        displayName: 'Quick Add',
        type: 'object',
        required: true,
        tabId: 'menu-appearance-settings-v2',
        fields: {
            isEnabled: {
                displayName: 'Enable quick add',
                type: 'bool',
                required: true,
                defaultValue: true,
            },
            eligibility: {
                displayName: 'Quick add eligibility',
                type: 'stringEnum',
                enum: QuickAddEligibility,
                required: true,
                ui: 'dropdown',
            },
            simpleItemsMode: {
                displayName: 'For items with no customizations',
                type: 'stringEnum',
                enum: QuickAddSimpleItemsMode,
                enumNameHelper: QuickAddSimpleItemsModeHelper.name,
                required: true,
                ui: 'dropdown',
            },
            showViewButtonForCustomizableItems: {
                displayName: "Show a 'View' button on cards for non-quick-add items that have customizations",
                type: 'bool',
                required: true,
                defaultValue: false,
            },
        },
    },
    bagOptInImage: {
        displayName: 'To Go Bag Opt-In Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 200,
            height: 200,
        },
        tooltip: {
            text: 'If provided, and the option is enabled on the To-Go dining option, this image is shown on the bag opt-in step.',
        },
        tabId: 'menu-appearance-settings-v2',
    },
    prependParentModNamesForNestedMods: {
        displayName: 'Prepend parent mod names for nested mods',
        type: 'bool',
        required: true,
        tabId: 'menu-appearance-settings-v2',
    },
    tableTentImage: {
        displayName: 'Table Tent Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 600,
            height: 400,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    showAddedToCartToast: {
        displayName: 'Show Added to Cart Toast',
        type: 'bool',
        required: true,
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    defaultScanImage: {
        displayName: 'Default Scan Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 600,
            height: 600,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
        tooltip: {
            text: 'This image is used as the fallback for the coupon, gift and comp card scanner images.',
        },
    },
    couponScanImage: {
        displayName: 'Coupon Scan Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 320,
            height: 320,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    giftCardScanImage: {
        displayName: 'Gift Card Scan Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 320,
            height: 320,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    compCardScanImage: {
        displayName: 'Comp Card Scan Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 320,
            height: 320,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    hidScanImage: {
        displayName: 'HID Tap Scan Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 320,
            height: 320,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    msrScanImage: {
        displayName: 'MSR Swipe Scan Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 320,
            height: 320,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    loadingSpinnerImage: {
        displayName: 'Loading Spinner Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        size: {
            width: 320,
            height: 320,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
        tooltip: {
            text: 'Custom image (e.g. an animated GIF) shown in place of the default loading spinner. Renders without rotation when set.',
        },
    },
    paymentSuccessImage: {
        displayName: 'Payment Success Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        keepAspectRatio: 'contain',
        size: {
            width: 1024,
            height: 1024,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'gcn',
    },
    paymentSuccessImageVitrine: {
        displayName: 'Payment Success Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        keepAspectRatio: 'contain',
        size: {
            width: 952,
            height: 476,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    paymentSuccessImageKioskToGo: {
        displayName: 'To Go Payment Success Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        keepAspectRatio: 'contain',
        size: {
            width: 952,
            height: 476,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    paymentSuccessImageKioskDineIn: {
        displayName: 'Dine In Payment Success Image',
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        keepAspectRatio: 'contain',
        size: {
            width: 952,
            height: 476,
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    displayDefaultModsInCart: {
        type: 'bool',
        required: true,
        displayName: 'Display Default Mods in Cart',
        tabId: 'menu-appearance-settings-v2',
        tooltip: {
            text: 'When viewing the checkout screen.',
        },
    },
    displayZeroDollarModsInCart: {
        type: 'bool',
        required: true,
        displayName: 'Display Zero Dollar Mods in Cart',
        tabId: 'menu-appearance-settings-v2',
        tooltip: {
            text: 'When viewing the checkout screen.',
        },
    },
    displayDeselectedModsInCart: {
        type: 'bool',
        required: true,
        displayName: 'Display Deselected Mods in Cart',
        tabId: 'menu-appearance-settings-v2',
        tooltip: {
            text: 'Will prefix deselected mods with DESELECTED_MOD_PREFIX custom string. When viewing the checkout screen.',
        },
    },
    displayModCodesInCart: {
        type: 'bool',
        required: true,
        displayName: 'Display Mod Codes in Cart',
        tabId: 'menu-appearance-settings-v2',
        tooltip: {
            text: 'When viewing the checkout screen the name of any sub mod codes that are automatically added will be prefixed before the name of the parent item.',
        },
    },
    displayModGroupsInCart: {
        type: 'bool',
        required: true,
        displayName: 'Display Mod Groups in Cart',
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
        tooltip: {
            text: 'When viewing the checkout screen, mods will be grouped under their mod group name and the ordered item card will use a three-column layout.',
        },
    },
    alwaysDisplayModGroupMagicCopyKeysInCart: {
        type: 'array',
        elementType: 'keyString',
        required: true,
        displayName: 'Always Display These Mod Groups in Cart',
        ui: 'table',
        placeholder: 'Select Mod Groups',
        writeRight: UserRight.ManageMenu,
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
        tooltip: {
            text: "Mods in these mod groups always show in the cart, even when Display Default Mods in Cart or Display Zero Dollar Mods in Cart are off. Mod groups are matched across locations by magic copy key, so a location whose mod group has a different key is not affected. At the org or site level the list covers every location's mod groups and can take up to a minute to load.",
        },
    },
    showSearch: {
        type: 'bool',
        required: true,
        displayName: 'Show Search',
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
        tooltip: {
            text: 'Will enable the search feature in the menu.',
        },
    },
    modGroupColumnCount: {
        type: 'int',
        displayName: 'Mod Group Column Count',
        min: 1,
        max: 4,
        defaultValue: 2,
        required: true,
        writeRight: UserRight.ManageMenu,
        tooltip: {
            text: 'Integer from 1 to 4',
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    specialRequestMaxLength: {
        type: 'int',
        displayName: 'Special Request Max Length',
        min: 15,
        max: 255,
        defaultValue: 255,
        required: true,
        writeRight: UserRight.ManageMenu,
        tooltip: {
            text: 'Maximum number of characters allowed in a special request when no POS integration specifies its own limit.',
        },
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
    },
    hideRequiredSingularModGroup: {
        type: 'bool',
        displayName: 'Hide modifier groups with mandatory, preselected, and singular modifier',
        defaultValue: false,
        required: true,
        writeRight: UserRight.ManageMenu,
        tabId: 'menu-appearance-settings-v2',
    },
    itemCardMultiPriceOptionDisplay: {
        type: 'stringEnum',
        enum: ItemCardMultiPriceOptionDisplay,
        enumNameHelper: ItemCardPriceOptionDisplayHelper.name,
        required: true,
        displayName: 'Item Card Multiple Price Options Display',
        tabId: 'menu-appearance-settings-v2',
        exclusiveTo: 'vitrine',
        ui: 'dropdown',
    },
    menuPageBackgroundImage: {
        type: 'array',
        elementType: 'object',
        elementSubtype: 'Image',
        elementUniqueIdFieldName: 'origUrl',
        maxCount: 1,
        displayName: 'Background Image',
        keepAspectRatio: 'fit-width',
        size: {
            width: 768,
            height: 432,
        },
        tabId: 'menu-appearance-settings-v2',
    },
    usePopupCloseButton: {
        type: 'bool',
        displayName: 'Use traditional close button for popups',
        tooltip: {
            text: 'GCN Only (will not be in vitrine)',
            isWarning: true,
        },
        required: true,
        tabId: 'menu-appearance-settings-v2',
    },
};
//# sourceMappingURL=settings_menu_appearance_schema.js.map